const FA3_EXECUTE_ROLE_IDS = new Set([
  'admin',
  'role_admin',
  'travelcrm:admin',
  'travelcrm.admin',
  'travelcrm/admin',
  'superadmin',
  'super-admin',
  'team_admin',
  'billing-admin',
]);

const FA3_VIEW_ROLE_IDS = new Set([
  ...Array.from(FA3_EXECUTE_ROLE_IDS),
  'clerk',
  'role_clerk',
  'travelcrm:clerk',
  'travelcrm.clerk',
  'travelcrm/clerk',
]);

export interface Fa3OperationsAccessPolicy {
  canViewOperations: boolean;
  canExecuteOperations: boolean;
}

export const resolveFa3OperationsAccessPolicy = (
  roles: string[] | null | undefined
): Fa3OperationsAccessPolicy => {
  const normalizedRoles = (roles ?? []).map((role) => role.trim().toLowerCase());
  const canExecuteOperations = normalizedRoles.some((role) => FA3_EXECUTE_ROLE_IDS.has(role));
  const canViewOperations =
    canExecuteOperations || normalizedRoles.some((role) => FA3_VIEW_ROLE_IDS.has(role));

  return {
    canViewOperations,
    canExecuteOperations,
  };
};
